import React, { useEffect, useState } from 'react';
import { isAuthenticated } from '../../../../services/auth';
import { toast } from 'react-toastify';
import moment from 'moment';
import {
  viewUser,
  followUser,
  unfollowUser,
  userActiveProducts,
} from '../../../../services/user';
import OptimizedList from '../../../../components/ui/lists/optimized-list';
import ProductCard from '../../../../components/product/product-card';
import { Card, Avatar, Button } from 'antd';

const ViewUser = ({ match, history }) => {
  const countPerPage = 6;
  const [values, setValues] = useState({
    _id: '',
    name: '',
    username: '',
    phone: '',
    photo: '',
    location: '',
    followers: '',
    products: [],
    createdAt: '',
  });
  const [activeProducts, setActiveProducts] = useState([]);
  const [following, setFollowing] = useState(null);
  const [current, setCurrent] = useState(1);
  const [pagination, setPagination] = useState([]);
  const positiveRating = [];
  const negativeRating = [];

  const {
    _id,
    followers,
    name,
    username,
    phone,
    photo,
    location,
    products,
    createdAt,
  } = values;
  const { user, token } = isAuthenticated();

  const loadUser = async () => {
    let res = await viewUser(match.params.userId);
    setValues({
      ...values,
      ...res.data,
    });
    res.data.ratings.forEach((item) => {
      if (item.rating === 'positive') {
        positiveRating.push(item._id);
      } else if (item.rating === 'negative') {
        negativeRating.push(item._id);
      }
    });
  };

  const loadUserActiveProducts = async (page) => {
    let res = await userActiveProducts(match.params.userId);
    setCurrent(page);
    const to = page * countPerPage;
    const from = to - countPerPage;
    setPagination(res.data.slice(from, to));
    setActiveProducts(res.data);
  };

  useEffect(() => {
    loadUser();
    loadUserActiveProducts(1);
  }, [following]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFollow = async () => {
    try {
      await followUser(match.params.userId, user, token);
      setFollowing(true);
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
    }
  };

  const handleUnfollow = async () => {
    try {
      await unfollowUser(match.params.userId, user, token);
      setFollowing(false);
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
    }
  };

  const API = (process.env.REACT_APP_API ).replace(
    /\/api$/,
    ''
  );

  function renderProductCard(product) {
    return (
      <ProductCard
        key={product._id}
        product={product}
        showActions={false}
        showAuthor={false}
        isAdmin={false}
        API={API}
      />
    );
  }

  return (
    <div className="view-user-page">
      <div className='view-user-container'>
        {/* Perfil lateral */}
        <div className='profile-sidebar'>
          <Card
            className='profile-card'
            cover={
              <div className='profile-cover'>
                <Avatar
                  src={photo ? `${API}${photo.replace(/^[\.\/]playnoimovel\.com\.br\/api/, '')}` : '/default-profile.png'}
                  className='avatar-user profile-avatar'
                  size={120}
                >
                  {name[0]}
                </Avatar>
                <div className='username'>@{username}</div>
                <div className='phone'>{phone}</div>
              </div>
            }
          >
            <div className='text-center mb-2 name'>{name}</div>
            {user && user._id !== _id && (
              <div className='action-buttons'>
                {followers.includes(user._id) ? (
                  <Button type='primary' danger shape='round' onClick={handleUnfollow} className='follow-btn'>
                    Deixar de seguir
                  </Button>
                ) : (
                  <Button type='primary' shape='round' onClick={handleFollow} className='follow-btn'>
                    Seguir
                  </Button>
                )}
                <Button
                  type='default'
                  shape='round'
                  onClick={() => history.push(`/messages?&message=${_id}`)}
                  className='message-btn'
                >
                  Mensagem
                </Button>
              </div>
            )}
            {location && location !== 'undefined' && (
              <div className='text-center mb-2 location-info'>
                <i className='fas fa-map-marker-alt me-2'></i>
                {location}
              </div>
            )}
            <div className='stats'>
              <div className='stat-item'>
                <div className='stat-label'>Seguidores</div>
                <div className='stat-value'>{followers.length}</div>
              </div>
              <div className='stat-item'>
                <div className='stat-label'>Produtos</div>
                <div className='stat-value'>{products.length}</div>
              </div>
            </div>
          </Card>
        </div>
        {/* Produtos do usuário */}
        <div className='products-section'>
          <div className='products-card'>
            <div className='products-header'>
              <h3 className='products-title'>
                Produtos de {username}
              </h3>
            </div>
            <div className='products-content'>
              <OptimizedList
                data={pagination}
                loading={false}
                pageSize={countPerPage}
                current={current}
                total={activeProducts.length}
                onPageChange={loadUserActiveProducts}
                renderItem={renderProductCard}
                emptyText='Nenhum produto encontrado'
                gridMode={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewUser;
